import React from 'react';
import { Section } from './ui/Section';
export function AuthorSection() {
  return <Section background="cream" data-id="element-1">
      <div className="max-w-xl mx-auto text-center" data-id="element-2">
        <div className="text-4xl mb-4" data-id="element-3">✍️</div>
        <blockquote className="text-[#2d3748] text-base md:text-lg italic leading-relaxed border-l-4 border-[#dc4a3d] pl-5 text-left bg-white p-5 rounded-r-xl shadow-sm" data-id="element-4">
          "Como experto en desarrollo infantil, he visto cómo familias se
          fracturan por una tablet. Diseñé este pack porque la paz en tu hogar
          no puede esperar. El futuro de tu hijo empieza con los límites que
          pongas hoy."
        </blockquote>
        <p className="mt-4 text-sm text-gray-500 font-medium" data-id="element-5">
          — Equipo Pantallas Bajo Control
        </p>
      </div>
    </Section>;
}